import { lazy } from "react";
import NetError from "@/pages/500";
import LoginMiddlewares from "@/middlewares/login-middlewares";

export const routes: Array<AppConfigs.RouteConfig> = [
  {
    path: "/",
    id: "layout",
    element: lazy(() => import("../layout")),
    children: [
      {
        path: "/",
        id: "home",
        title: "首页",
        redirect: "/app-download",
      },
      {
        path: "/login",
        id: "login",
        title: "登录",
        element: lazy(() => import("@/pages/login")),
      },
      {
        path: "/chat",
        id: "online_customer_service",
        title: "在线客服",
        element: lazy(() => import("@/pages/customer-service")),
        middlewares: [LoginMiddlewares],
      },
      {
        path: "/health-report/week",
        id: "health_report_week",
        title: "健康周报",
        element: lazy(() => import("@/pages/activity-weekly")),
        // element: lazy(() => import("@/pages/health-report/week")),
        middlewares: [LoginMiddlewares],
      },
      {
        path: "/webview",
        id: "webview",
        title: "内容查看",
        element: lazy(() => import("@/pages/webview")),
      },
      {
        path: "/app-download",
        id: "app_download",
        title: "APP下载",
        element: lazy(() => import("@/pages/app-download")),
      },
      {
        path: "/test-invitation",
        id: "test_invitation",
        title: "内测活动",
        element: lazy(() => import("@/pages/test-invitation")),
      },
      {
        path: "/activity",
        id: "activity",
        title: "Apexmove内测活动",
        element: lazy(() => import("@/pages/activity")),
      },
      {
        path: "/link-redirect",
        id: "link-redirect",
        title: "内测活动独立站跳转中转页",
        element: lazy(() => import("@/pages/link-redirect")),
      },
      {
        path: "/questionnaire",
        id: "questionnaire",
        title: "问卷调查",
        element: lazy(() => import("@/pages/questionnaire")),
      },
      {
        path: "/lottery",
        id: "lottery",
        title: "开奖",
        element: lazy(() => import("@/pages/activity/lottery")),
      },
      {
        path: "/test",
        id: "test",
        title: "功能测试",
        element: lazy(() => import("@/pages/test")),
      },
      {
        path: "/500",
        id: "500",
        title: "网络错误",
        element: NetError,
      },
    ],
  },
  {
    path: "*",
    id: "page_not_found",
    title: "页面未找到",
    element: lazy(() => import("@/pages/404")),
  },
];
